import { fromJS } from 'immutable';

export const immutablePage = (pageName) => {
  const page = Object.freeze({
    route: { topLevelRouteName: pageName },
  });
  return fromJS(page);
};
